document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        document.querySelectorAll('.combo_devx_btn').forEach(button => {
            button.removeAttribute('disabled'); // Ensure button is always enabled
        });
    }, 500);

    // MutationObserver to prevent the button from being disabled
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'disabled') {
                mutation.target.removeAttribute('disabled');
            }
        });
    });

    document.querySelectorAll('.combo_devx_btn').forEach(button => {
        observer.observe(button, { attributes: true });
    });
});

(function () {
    function initComboSection() {
      document.querySelectorAll('.npdp-combo-accordion').forEach(function (comboSection) {
        const comboCards = comboSection.querySelectorAll('.combo-variant-button');
  
        // Auto-select 2nd card if available
        if (comboCards.length > 1) {
          const defaultCard = comboCards[1];
          defaultCard.classList.add('active_combo');
          updateInputsAndPrice(defaultCard, comboSection);
        }
  
        // Click listener for each card
        comboCards.forEach(function (card) {
          card.addEventListener('click', function () {
            comboCards.forEach(c => c.classList.remove('active_combo'));
            this.classList.add('active_combo');
            updateInputsAndPrice(this, comboSection);
          });
        });
      });
    }
  
    // Function to update hidden inputs and button price
    function updateInputsAndPrice(card, comboSection) {
      const variantId = card.dataset.comboVariantId;
      const productId = card.dataset.productId;
      const price = card.dataset.productPrice?.replace('₹', '');
  
      const variantInput = comboSection.querySelector('.dev_get_combo_variantid');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
  
      const productInput = comboSection.querySelector('.dev_getproductid');
      if (productInput && productId) {
        productInput.value = productId;
      }
  
      const comboBtn = comboSection.querySelector('.combo_devx_btn');
      if (comboBtn && price) {
        const existingPrice = comboBtn.querySelector('.added-price');
        const priceHTML = `<span class="added-price" style="margin-left: 10px; font-weight: bold;">- <span class="rupee-foradian">₹</span>${price}</span>`;
  
        if (existingPrice) {
          existingPrice.innerHTML = `- <span class="rupee-foradian">₹</span>${price}`;
        } else {
          comboBtn.insertAdjacentHTML('beforeend', priceHTML);
        }
      }
    }
  
    // Wait for element to appear in DOM
    function waitForComboAccordion(callback) {
      const interval = setInterval(() => {
        if (document.querySelector('.npdp-combo-accordion')) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    }
  
    // Initial on page load
    document.addEventListener('DOMContentLoaded', function () {
      waitForComboAccordion(initComboSection);
    });
  
    // Re-run on Shopify section load (for theme editor or dynamic rendering)
    document.addEventListener('shopify:section:load', function () {
      waitForComboAccordion(initComboSection);
    });
  
    // Fallback for dynamically inserted HTML
    window.addEventListener('load', function () {
      waitForComboAccordion(initComboSection);
    });
  })();
  